import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const tooltipDataSelector = (state: RootState) => state.tooltips.data;

export const tooltipDefinitionSelector = createSelector(tooltipDataSelector, data => {
  return (term: string) => {
    const found = data.find(item => item.Term === term);

    if (!found) {
      return `No definition for ${term} found`;
    }

    return found.Definition;
  };
});
